import React from 'react';

import FieldMultiPhone from '../common/FieldMultiPhone';
import FieldText from '../common/FieldText';

class PropertyOwnerDetails extends React.Component {
  render() {
    const fields = this.props.model.fields;
    const property = this.props.property;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    return (
      <>
        <div className="formhead col-md-12"><h2>Property Owner Details</h2></div>
        
        <FieldText key="contact~name" id="contact~name"  field={fields['contact~name']} 
          value={property['contact~name']} onValueChange={onValueChange} inValid={inValid} />
        
        <FieldMultiPhone key="contact~phone" id="contact~phone" field={fields['contact~phone']}
          value={property['contact~phone']} onValueChange={onValueChange} inValid={inValid} />
      </>
    );
  }
}

export default PropertyOwnerDetails;